module.exports = __webpack_public_path__ + "static/media/9DESA20.878e2e9b.jpg";